// Modules
import _ from 'lodash'
import { call, put, select, takeLatest } from 'redux-saga/effects'

// Languages
import { LN_NOTIFICATIONS_GET_MARKET_LIST } from 'locales/constants'
import i18n from 'locales/i18n'

// Constants
import { toastConstructor, toastType } from 'components/ToastApp/constants'

import { localStorageFavouritesKey } from 'constants/index'

// Utils
import { findElemInListCurrency } from 'utils/findElemInListCurrency'

// Store
import {
  setAccordionTitlesList,
  setCurrencyMapMarketList,
  setCurrencyMarketList,
  setCurrencyMarketListLoading,
  setOpenAccordionPanelGroupId,
  setOpenAccordionPanelGroupList,
  setUpdatedCurrencyList,
} from 'store/actions/CurrencySocket/actions'
import { GET_CURRENCY_MARKET_LIST } from 'store/actions/CurrencySocket/types'
import { setFavouriteList } from 'store/actions/FavouritesCurrency/actions'
import { showToast } from 'store/actions/ToastsApp/actions'
import { setExpandableAccordionInds } from 'store/actions/marketSidebar/actions'
import { getCurrencyListAPI } from 'store/api/market'
import { getErrorMessage, onUserNotAuth } from 'store/sagas/utils'

function* getAllCurrencyList() {
  const t = i18n.t.bind(i18n)
  try {
    const { token, favouritesCurrencyList, chosenActiveTradeItem } = yield select((state) => ({
      token: state.auth.token,
      favouritesCurrencyList: state.favouritesCurrencyList.favouritesCurrencyList,
      chosenActiveTradeItem: state.activeTradeItems.chosenActiveTradeItem,
    }))

    if (token) {
      const listResponse = yield call(getCurrencyListAPI)

      const updatedFavourites = favouritesCurrencyList.map((el) => {
        const updatedItem = findElemInListCurrency(el?.name, listResponse?.currencies)
        return updatedItem ? { ...el, price: updatedItem?.price, spread: updatedItem?.spread } : el
      })

      const currencies = listResponse?.currencies
      // Update store and localStorage with new values
      localStorage.setItem(localStorageFavouritesKey, JSON.stringify(updatedFavourites))
      yield put(setCurrencyMarketList(currencies))
      yield put(setUpdatedCurrencyList(currencies))

      if (!_.isEmpty(currencies)) {
        const keys = _.keys(currencies)
        yield put(setAccordionTitlesList(keys))
        yield put(setOpenAccordionPanelGroupId(keys[0]))
        yield put(setOpenAccordionPanelGroupList(currencies?.[keys[0]] || null))
        yield put(setExpandableAccordionInds([keys?.[0]]))
      }
      yield put(setCurrencyMapMarketList(listResponse?.currencyMap || null))
      yield put(setFavouriteList(updatedFavourites))
    }
  } catch (error) {
    yield put(setCurrencyMarketListLoading(false))
    yield put(setCurrencyMarketList(null))
    yield put(setCurrencyMapMarketList(null))

    const result = yield call(getErrorMessage, error)
    yield put(
      showToast(toastConstructor(toastType.error, result, t(LN_NOTIFICATIONS_GET_MARKET_LIST))),
    )
    yield call(onUserNotAuth, error)
  } finally {
    yield put(setCurrencyMarketListLoading(false)) // Ensure loading state is set to false on completion
  }
}

export function* watchMainCurrencySidebar() {
  yield takeLatest(GET_CURRENCY_MARKET_LIST, getAllCurrencyList)
}
